import accessories from './accessories';
import areas from './areas';
import budgets from './budgets';
import cardAdministrators from './cardAdministrators';
import commons from './commons';
import companies from './companies';
import consumables from './consumables';
import costCenters from './costCenters';
import customers from './customers';
import dashboard from './dashboard';
import diagnostics from './diagnostics';
import documentTypes from './documentTypes';
import employee from './employee';
import groups from './groups';
import helpCenter from './helpCenter';
import home from './home';
import layout from './layout';
import login from './login';
import manufacturers from './manufacturers';
import ncm from './ncm';
import parts from './parts';
import paymentConditions from './paymentConditions';
import planAccounts from './planAccounts';
import profiles from './profiles';
import quotations from './quotations';
import register from './register';
import schedules from './schedules';
import settings from './settings';
import stockCorrections from './stockCorrections';
import suppliers from './suppliers';
import insurers from './insurers';
import bankAccounts from './bankAccounts';
import tasks from './tasks';
import tax from './tax';
import users from './users';
import workOrders from './workOrders';
import searchQuestionnaire from './searchQuestionnaire';
import shippingOptions from './shippingOptions';
import releaseBillToPay from './releaseBillToPay';
import predictionBillToPay from './predictionBillToPay';
import groupingBillToPay from './groupingBillToPay';
import releaseBillToReceiver from './releaseBillToReceiver';
import groupingBillToReceiver from './groupingBillToReceiver';
import releaseBankEntry from './releaseBankEntry';
import movementInventory from './movementInventory';
import cashMovement from './cashMovement';
import directSale from './directSale';
import purchases from './purchases';
import purchaseReturn from './purchaseReturn';
import purchasingGrouping from './purchasingGrouping';
import informative from './informative';
import invoice from './invoice';
import notifications from './notifications';
import deliveryOrReturnOfMaterials from './deliveryOrReturnOfMaterials';
import reportStock from './reportStock';
import movementWorkOrdersReport from './movementWorkOrdersReport';
import byMoviments from './byMoviments';
import financialBillsToPay from './financialBillsToPay';
import movementDailyMovementReport from './movementDailyMovementReport';
import movementDirectSale from './movementDirectSale';
import movementOsXFinancial from './movementOsXFinancial';
import movementDirectSaleXFinancial from './movementDirectSaleXFinancial';
import movementCustomerWithoutMovement from './movementCustomerWithoutMovement';
import reportInvoice from './reportInvoice';
import salesByCST from './salesByCST';
import productiveHoursSold from './productiveHoursSold';
import managerialInvoicing from './managerialInvoicing';
import purchasesPurchaseReport from './purchasesPurchaseReport';
import byFinancial from './byFinancial';
import financialBillsToReceive from './financialBillsToReceive';
import purchasesQuotationReport from './purchasesQuotationReport';
import returnedPurchases from './returnedPurchases';
import purchasesAbcCurveReport from './purchasesAbcCurveReport';
import financialDre from './financialDre';
import reportFinancialCashFlow from './reportFinancialCashFlow';
import reportManagerialCost from './reportManagerialCost';
import financialBalancete from './financialBalancete';
import stockDeliveryOfMaterial from './stockDeliveryOfMaterial';
import consolidatedReportStock from './consolidatedReportStock';
import productiveHoursCost from './productiveHoursCost';
import stockMinimumStock from './stockMinimumStock';
import invoiceNoteItems from './invoiceNoteItems';
import searchParts from './searchParts';
import stone from './stone';
import invoicePaymentCondition from './invoicePaymentCondition';
import searchPartStock from './searchPartStock';
import invoiceTaxes from './invoiceTaxes';
import invoiceTransport from './invoiceTransport';
import vehiclesHistory from './vehiclesHistory';
import purchaseImport from './purchaseImport';
import quotationRequest from './quotationRequest';

export default {
  ...accessories,
  ...areas,
  ...budgets,
  ...cardAdministrators,
  ...commons,
  ...companies,
  ...consumables,
  ...costCenters,
  ...customers,
  ...dashboard,
  ...diagnostics,
  ...documentTypes,
  ...employee,
  ...groups,
  ...helpCenter,
  ...home,
  ...layout,
  ...login,
  ...manufacturers,
  ...ncm,
  ...parts,
  ...paymentConditions,
  ...planAccounts,
  ...profiles,
  ...quotations,
  ...register,
  ...schedules,
  ...settings,
  ...stockCorrections,
  ...suppliers,
  ...insurers,
  ...bankAccounts,
  ...tasks,
  ...tax,
  ...users,
  ...workOrders,
  ...searchQuestionnaire,
  ...shippingOptions,
  ...releaseBillToPay,
  ...predictionBillToPay,
  ...groupingBillToPay,
  ...releaseBillToReceiver,
  ...groupingBillToReceiver,
  ...releaseBankEntry,
  ...movementInventory,
  ...cashMovement,
  ...purchases,
  ...purchaseReturn,
  ...purchasingGrouping,
  ...directSale,
  ...informative,
  ...invoice,
  ...notifications,
  ...deliveryOrReturnOfMaterials,
  ...reportStock,
  ...movementWorkOrdersReport,
  ...byMoviments,
  ...financialBillsToPay,
  ...movementDailyMovementReport,
  ...movementDirectSale,
  ...movementOsXFinancial,
  ...movementDirectSaleXFinancial,
  ...movementCustomerWithoutMovement,
  ...reportInvoice,
  ...salesByCST,
  ...productiveHoursSold,
  ...managerialInvoicing,
  ...purchasesPurchaseReport,
  ...byFinancial,
  ...financialBillsToReceive,
  ...purchasesQuotationReport,
  ...returnedPurchases,
  ...purchasesAbcCurveReport,
  ...financialDre,
  ...reportFinancialCashFlow,
  ...reportManagerialCost,
  ...financialBalancete,
  ...stockDeliveryOfMaterial,
  ...consolidatedReportStock,
  ...productiveHoursCost,
  ...stockMinimumStock,
  ...invoiceNoteItems,
  ...searchParts,
  ...searchPartStock,
  ...stone,
  ...invoicePaymentCondition,
  ...invoiceTaxes,
  ...invoiceTransport,
  ...vehiclesHistory,
  ...purchaseImport,
  ...quotationRequest,
};
